module.exports = __webpack_public_path__ + "static/media/hip_flex.7c442174.png";